import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type listCancelReasonsResponse = {
  cancelReasons: UnsuccessfulReasonDto[];
};

export type UnsuccessfulReasonDto = {
  id: string;
  name: string;
  isCommercial: boolean;
};

export const listCancelReasons = async () => {
  const response = await executeApiRequest(() => axios.get<listCancelReasonsResponse>("/requests/cancelreasons"));
  return response?.data.cancelReasons;
};
